import React from "react";

function SocialAcc() {
  return (
    <>
      <div className="social-acc">
        <ul>
          <li>
            <a href="https://github.com/Lasyanga" rel="noopener noreferrer" target="_blank">
              <i className="bx bxl-github bx-md"></i>
            </a>
          </li>
          <li>
            <a href="https://www.messenger.com/t/100005793018373" rel="noopener noreferrer" target="_blank">
              <i className="bx bxl-messenger bx-md"></i>
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/herminigildo-jr-quiano-1755421bb" rel="noopener noreferrer" target="_blank">
              <i className="bx bxl-linkedin bx-md"></i>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}

export default SocialAcc;
